
export const environment = {
  production: true,
  apiEndpoint: 'https://cercla.ba.ars.usda.gov/USDAIrar',
  clientId: '099153c2625149bc8ecb3e85e03f0022',
  showSignupLink: false
};



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/environments/environment.ts